///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { SuiTopologyPreferencesDTO } from '../generated/shared-sui-types.model';
import { TopologyPreferencesDTO } from '../generated/shared-types.model';

@Injectable({
    providedIn: null
})
export class GtthPreferencesService {
    private readonly resourceUrl = 'api/projects/topology-preferences';

    constructor(private readonly http: HttpClient) {}

    getPreferences(): Observable<SuiTopologyPreferencesDTO> {
        return this.http.get<TopologyPreferencesDTO>(this.resourceUrl).pipe(
            map((res: TopologyPreferencesDTO) => {
                // convert values to percents
                for (const key of Object.keys(res)) {
                    res[key] = isNaN(Number(res[key])) ? 0 : res[key] * 100;
                }
                return new SuiTopologyPreferencesDTO(res);
            })
        );
    }

    createPreferences(topologyPreferences: SuiTopologyPreferencesDTO): Observable<SuiTopologyPreferencesDTO> {
        const preferences: TopologyPreferencesDTO = topologyPreferences.toDto();

        // convert values to decimals
        for (const key of Object.keys(preferences)) {
            preferences[key] /= 100;
        }
        return this.http.post<SuiTopologyPreferencesDTO>(this.resourceUrl, preferences);
    }
}
